/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stats_AlignmentInputs */

const en_home_stats_alignment = /** @type {(inputs: Home_Stats_AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of AI scientists believe that the technical challenge of aligning AIs with human values is real & important`)
};

/**
* | output |
* | --- |
* | "of AI scientists believe that the technical challenge of aligning AIs with human values is real & important" |
*
* @param {Home_Stats_AlignmentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_stats_alignment = /** @type {((inputs?: Home_Stats_AlignmentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stats_AlignmentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_stats_alignment(inputs)
});